import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import Header from 'containers/header';
import Footer from 'containers/footer';
import Info from 'containers/info';
import EthereumTool from 'containers/ethereum';
import NotFound from 'containers/404';
import AuthenticationPage from "containers/auth/AuthenticationPage";
import { cognitoAuthentication } from "containers/auth/CognitoAuthentication";

import 'static/styles/index.css';
import background from 'static/images/team-banner.png';

const style = {
  backgroundImage: `url(${background})`,
  backgroundColor: '#20262f',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  height: '312px',
  position: 'relative'
};

class App extends Component {
  render() {
    return (
      <div id="site_wrapper">
        <div className="site-upper" style={style}>
          <Header />
          <Info />
        </div>
        <Switch>
          <Redirect exact from="/" to="/tools" />
          <Route path="/tools" component={EthereumTool} />
          <Route path="/auth" component={cognitoAuthentication(AuthenticationPage)} />
          <Route path="*" component={NotFound} />
        </Switch>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));